import { render } from "./InformativeIcon.vue?vue&type=template&id=515f201e&ts=true"
import script from "./InformativeIcon.vue?vue&type=script&lang=ts"
export * from "./InformativeIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__